import api from '@/api'

export default {
	methods: {
		async login() {
			if (window.googleToken?.credential) {
				const res = await api.login({
					ggToken: window.googleToken.credential,
				})
				if (res?.tokenValue) {
					this.$store.state.isAuth = true
					this.$cookies.set(res.tokenName, res.tokenValue)
					this.go('/')
					this.$message({
						message: 'Login success!',
						type: 'success',
						duration: 3000,
					})
					setTimeout(async () => {
						const userInfo = await api.getUserInfo()
						console.log('userInfo: ', userInfo.user)
						this.$store.state.userInfo = {
							...userInfo.user,
							...res,
						}
						this.$store.state.avatar = userInfo.user.avatar
					})
				}
				console.log('🚀🚀🚀 login res: ', res)
			} else {
				return
			}
		},
	},
	mounted() {
		const that = this
		// 植入获取token的回掉等待google登陆成功后自动调用获取token
		window.handleToken = (token) => {
			window.googleToken = token
			console.log('🚀🚀🚀 window.googleToken: ', token)
			that.login()
		}
	},
	metaInfo() {
    const description = this.domainConfig.loginDesc
		return {
			title: "Login",
			meta: [
				{
					name: 'description',
					content: description,
				},
			],
		}
	},
}
